import {LeagueType} from '../LeaderBoardStore/LeaderBoardStore.constants';
import {StatisticsTabsType} from './GameStatisticsStore.constants';
import {
  GameStatisticsLeagueProgress,
  GameStatisticsState,
  PersonalGameStatistics,
  PersonalGameStatisticsItem,
  ProjectGameStatisticsItem,
} from './GameStatisticsStore.types';

import {Store} from '../Store';

export class GameStatisticsStore extends Store<GameStatisticsState> {
  private leagueOrder: LeagueType[];

  constructor() {
    super({
      activeTab: StatisticsTabsType.Personal,
      personal: {
        energyMultiplier: 0,
        energyRechargers: 0,
        incomePerHour: 0,
        activeGems: 0,
        passiveGems: 0,
        improvements: 0,
        improvementUpgrades: 0,
        gifts: 0,
        tasks: 0,
        dailyGames: 0,
        tickets: 0,
        energySpent: 0,
        energyRechargersSpent: 0,
        gemsSpent: 0,
        leagueProgress: [],
      },
      projectDT: null,
    });

    this.leagueOrder = [LeagueType.Bronze, LeagueType.Silver, LeagueType.Gold, LeagueType.Diamond];
  }

  public setActiveTab = (tab: StatisticsTabsType): void => {
    this.setValue('activeTab', tab);
  };

  public isActiveTabPersonal = (): boolean => {
    return this.getState().activeTab === StatisticsTabsType.Personal;
  };

  public isActiveTabProject = (): boolean => {
    return this.getState().activeTab === StatisticsTabsType.Project;
  };

  public setPersonal = (personal: PersonalGameStatistics): void => {
    this.setValue('personal', personal);
  };

  public setProjectDT = (projectDT: ProjectGameStatisticsItem[] | null): void => {
    this.setValue('projectDT', projectDT);
  };

  public getProjectDT = (): ProjectGameStatisticsItem[] | null => {
    return this.getState().projectDT;
  };

  public isLeagueUp(leagueA: LeagueType, leagueB: LeagueType): boolean {
    const posA = this.getLeagueOrderPosition(leagueA);
    const posB = this.getLeagueOrderPosition(leagueB);

    return posA < posB;
  }

  public isLeagueDown(leagueA: LeagueType, leagueB: LeagueType): boolean {
    const posA = this.getLeagueOrderPosition(leagueA);
    const posB = this.getLeagueOrderPosition(leagueB);

    return posA > posB;
  }

  public isLeaguesEqual(leagueA: LeagueType, leagueB: LeagueType): boolean {
    const posA = this.getLeagueOrderPosition(leagueA);
    const posB = this.getLeagueOrderPosition(leagueB);

    return posA === posB;
  }

  public getSortedUserLeagueProgress(): GameStatisticsLeagueProgress[] {
    return this.state.personal.leagueProgress.sort((a, b) => a.periodNumber - b.periodNumber);
  }

  public getPersonalStatisticsValue(item: PersonalGameStatisticsItem): number {
    const statistics = this.state.personal;

    switch (item) {
      case PersonalGameStatisticsItem.PersonalEnergyMultiplier:
        return statistics.energyMultiplier;
      case PersonalGameStatisticsItem.PersonalEnergyRechargers:
        return statistics.energyRechargers;
      case PersonalGameStatisticsItem.PersonalIncomePerHour:
        return statistics.incomePerHour;
      case PersonalGameStatisticsItem.PersonalActiveGems:
        return statistics.activeGems;
      case PersonalGameStatisticsItem.PersonalPassiveGems:
        return statistics.passiveGems;
      case PersonalGameStatisticsItem.PersonalImprovements:
        return statistics.improvements;
      case PersonalGameStatisticsItem.PersonalImprovementUpgrades:
        return statistics.improvementUpgrades;
      case PersonalGameStatisticsItem.PersonalGifts:
        return statistics.gifts;
      case PersonalGameStatisticsItem.PersonalTasks:
        return statistics.tasks;
      case PersonalGameStatisticsItem.PersonalDailyGames:
        return statistics.dailyGames;
      case PersonalGameStatisticsItem.PersonalTickets:
        return statistics.tickets;
      case PersonalGameStatisticsItem.PersonalEnergySpent:
        return statistics.energySpent;
      case PersonalGameStatisticsItem.PersonalEnergyRechargersSpent:
        return statistics.energyRechargersSpent;
      case PersonalGameStatisticsItem.PersonalGemsSpent:
        return statistics.gemsSpent;
    }

    return 0;
  }

  private getLeagueOrderPosition(league: LeagueType): number {
    return this.leagueOrder.findIndex((item) => item === league);
  }
}
